import { useState } from "react";
import { Period, Record } from "../../types";
import ManageRecordForm from "../../components/ManageRecordForm";
import MaterialIcon from "../../components/MaterialIcon";

interface AddRecordSectionProps {
  addRecord: (record: Record) => void;
  period: Period;
  records: Record[];
}

function AddRecordSection({
  addRecord,
  period,
  records,
}: AddRecordSectionProps) {
  let [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <section className="bg-grayscale-800 shadow-grayscale-900 w-full rounded-lg p-3 shadow lg:order-3 lg:w-auto">
        <div
          className="flex justify-between lg:justify-center"
          onClick={() => setOpen(!open)}
        >
          <div className="w-6 lg:hidden"></div>
          <h2 className="w-auto shrink text-center font-semibold">
            Add Record
          </h2>
          <button className="w-6 lg:hidden">
            <MaterialIcon
              icon={open ? "keyboard_arrow_down" : "keyboard_arrow_right"}
            />
          </button>
        </div>
        <div className={`${open ? "block" : "hidden"} lg:block`}>
          <ManageRecordForm
            handleSubmit={addRecord}
            period={period}
            record={null}
            records={records}
          />
        </div>
      </section>
    </>
  );
}

export default AddRecordSection;
